import uploader from 'services/file-upload';
import { getAudioMarker, getAudioMarkerUrl } from 'shared/helpers/markers';
import Encoder from 'services/encoder';

function getPendingUpload(audio) {
  if (audio) {
    return uploader.get(audio.id, 'media');
  }

  return null;
}

function getEncodingJob(markers) {
  const mediaUrl = getAudioMarkerUrl(markers);

  return mediaUrl ? Encoder.getJobForMediaUrl(mediaUrl) : null;
}

function hasPendingUpload(audio) {
  return getPendingUpload(audio) !== null;
}

function getAudioFilename(markers) {
  const audioMarker = getAudioMarker(markers);
  const upload = getPendingUpload(audioMarker);

  if (upload) {
    return upload.fileName;
  }

  if (audioMarker) {
    const audioUrl = getAudioMarkerUrl(markers);

    if (audioUrl) {
      let fileName = audioUrl.substring(audioUrl.lastIndexOf('/') + 1);

      if (fileName.substring(0, 6) === 'media-') {
        fileName = fileName.substring(6);
        const firstDash = fileName.indexOf('-');
        if (firstDash > -1) {
          fileName = fileName.substring(firstDash + 1);
        }
      }
      return fileName;
    }
  }
  return '...';
}

export default {
  getPendingUpload,
  hasPendingUpload,
  getAudioMarker,
  getAudioFilename,
  getEncodingJob,
};
